module.exports = __webpack_public_path__ + "img/zusor_light.f54a1900.svg";